// extracted by mini-css-extract-plugin
export var category = "_ho-9";
export var categoryHeader = "_ho-e";
export var container = "_ho-0";
export var group = "_ho-a";
export var groupItems = "_ho-f";
export var groupSeparator = "_ho-j";
export var loading = "_ho-1";
export var noResults = "_ho-3";
export var placeholder = "_ho-2";
export var resultContent = "_ho-5";
export var resultIcon = "_ho-c";
export var resultItem = "_ho-g";
export var resultMeta = "_ho-8";
export var resultSubtitle = "_ho-7";
export var resultSuffix = "_ho-i";
export var resultTitle = "_ho-6";
export var resultsList = "_ho-4";
export var searchGroup = "_ho-d";
export var selected = "_ho-h";
export var subgroup = "_ho-b";